import {WebApiRequest, HTTP_GET, HTTP_POST, HTTP_PUT, HTTP_DELETE } from "tools/webservice";
import api from "apis/customerConfiguration";


export const getMCardConfiguration = (customerNumber, surveyTypeCode, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getMCardConfiguration(customerNumber, surveyTypeCode),
  successCallback: successCallback,
  mountedRef: mountedRef,
});

export const getMCardData = (customerNumber, surveyTypeCode, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getMCardData(customerNumber, surveyTypeCode),
  successCallback: successCallback,
  mountedRef: mountedRef,
});

export const updateMCardData = (customerNumber, surveyTypeCode, data, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: data,
  endpoint: api.updateMCardData(customerNumber, surveyTypeCode),
  successCallback: successCallback,
  errorCallback: errorCallback,
  mountedRef: mountedRef,
});

export const getSurveyTypeForms = (customerNumber, surveyTypeCode, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getSurveyTypeForms(customerNumber, surveyTypeCode),
  successCallback: successCallback,
  mountedRef: mountedRef,
});

export const addFormToSurveyType = (customerNumber, surveyTypeCode, formCode, data, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: data,
  endpoint: api.addUpdateRemoveForm(customerNumber, surveyTypeCode, formCode),
  successCallback: successCallback,
  mountedRef: mountedRef,
});

export const removeFormFromSurveyType = (customerNumber, surveyTypeCode, formCode, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: api.addUpdateRemoveForm(customerNumber, surveyTypeCode, formCode),
  successCallback: successCallback,
  mountedRef: mountedRef,
});

export const updateFormOnSurveyType = (customerNumber, surveyTypeCode, formCode, data, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  payload: data,
  endpoint: api.addUpdateRemoveForm(customerNumber, surveyTypeCode, formCode),
  successCallback: successCallback,
  mountedRef: mountedRef,
});

export const getSurveyTypeNotifications = (customerNumber, surveyTypeCode, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.notifications(customerNumber, surveyTypeCode),
  successCallback: successCallback,
  mountedRef: mountedRef,
});

export const addNotification = (customerNumber, surveyTypeCode, notificationTypeCode, notification, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.addUpdateRemoveNotifications(customerNumber, surveyTypeCode, notificationTypeCode),
  payload: notification,
  successCallback: successCallback,
  errorCallback: errorCallback,
  mountedRef: mountedRef,
});

export const updateNotification = (customerNumber, surveyTypeCode, notificationTypeCode, notification, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: api.addUpdateRemoveNotifications(customerNumber, surveyTypeCode, notificationTypeCode),
  payload: notification,
  successCallback: successCallback,
  errorCallback: errorCallback,
  mountedRef: mountedRef,
});

export const deleteNotification = (customerNumber, surveyTypeCode, notificationTypeCode, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: api.addUpdateRemoveNotifications(customerNumber, surveyTypeCode, notificationTypeCode),
  successCallback: successCallback,
  errorCallback: errorCallback,
  mountedRef: mountedRef,
});

export const copySurveyType = (customerNumberTo, surveyTypeCode, customerNumberFrom, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.copySurveyType(customerNumberTo, surveyTypeCode, customerNumberFrom),
  successCallback: successCallback,
  errorCallback: errorCallback,
  mountedRef: mountedRef,
});